import React from 'react';
import { Form, Input } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { emailTemplatePlaceholders, ReferralTemplatesFormProps } from '../types';
import { createPlaceholdersValidatorRule, getPlaceholdersHint } from '../validators';
import ResetFieldButton from '../../../Common/ResetFieldButton';

const defaultValue = `Hallo {{invitedName}},

dein Freund {{inviterName}} lädt dich ein!

{{link}}

Viele Grüße,
{{inviterName}}`;

const prefix: keyof ReferralTemplatesFormProps = 'emailTemplate';

function EmailTemplate() {
  const form = useFormInstance();

  const handleReset = () => {
    form.setFieldValue(prefix, defaultValue);
    form.validateFields([prefix]);
  };

  return (
    <Form.Item
      label={(
        <div className="centered-content">
          Email Template
          <ResetFieldButton onClick={handleReset} />
        </div>
      )}
      name={prefix}
      extra={getPlaceholdersHint(emailTemplatePlaceholders)}
      rules={[createPlaceholdersValidatorRule(emailTemplatePlaceholders)]}
    >
      <Input.TextArea placeholder="Enter email template text" maxLength={3000} showCount rows={8} />
    </Form.Item>
  );
}

export default EmailTemplate;
